module.exports = [
  {
    de: 'Allgemein',
    vocabularies: [
      {
        de: 'Ja',
        ru: 'да',
        vocal: 'da',
      },
      {
        de: 'Nein',
        ru: 'нет',
        vocal: 'net',
      },
      {
        de: 'vielleicht',
        ru: 'может быть',
        vocal: 'mо̒shet byt',
      },
      {
        de: 'Bitte',
        ru: 'пожалуйста',
        vocal: 'pashа́lujßta',
      },
      {
        de: 'Danke',
        ru: 'спасибо',
        vocal: 'ßpaßi̒ba',
      },
      {
        de: 'Entschuldigung',
        ru: 'извините',
        vocal: 'iswini̒te',
      },
      {
        de: 'Alles klar',
        ru: 'ясно, ладно',
        vocal: 'jа́ßna, lа́dna',
      },
      {
        de: 'Ich verstehe (nicht)',
        ru: 'Я (не) понимаю',
        vocal: 'Ja (ni) panimа́ju',
      },
      {
        de: 'Sprechen Sie Deutsch?',
        ru: 'Вы говорите по-немецки?',
        vocal: 'Wy gawari̒te pa-nimе́tzki?',
      },
      {
        de: 'Ich spreche kein Deutsch',
        ru: 'Я не говорю по-немецки',
        vocal: 'Ja ni gawarju̒ pa-nimе́tzki.',
      },
      {
        de: 'Hilfe!',
        ru: 'Помогите!',
        vocal: 'Pamagi̒te!',
      },
      {
        de: 'Ein bisschen langsamer bitte',
        ru: 'Немного помедленнее, пожалуйста',
        vocal: 'Nimnо́ga pamе́dlinije, pashа́lujßta',
      },
      {
        de: 'Gesundheit!',
        ru: 'Будь здоров(а)! Будьте здоровы!',
        vocal: 'Bud sdarо́w(a)! Bu̒dtje sdarо́wy!',
      },
      {
        de: 'Prost!',
        ru: 'Твое (Ваше) здоровье!',
        vocal: 'Twajо́ (Wа́sche) sdarо́wje!',
      },
      {
        de: 'Wo',
        ru: 'где',
        vocal: 'gde',
      },
      {
        de: 'Wann',
        ru: 'когда',
        vocal: 'kagdа́',
      },
      {
        de: 'Wer',
        ru: 'кто',
        vocal: 'kto',
      },
      {
        de: 'Warum',
        ru: 'почему',
        vocal: 'patschimu̒',
      },
    ],
  },
  {
    de: 'Vorstellungen',
    vocabularies: [
      {
        de: 'Name',
        ru: 'имя',
        vocal: 'i̒mja',
      },
      {
        de: 'Wie heißen Sie?',
        ru: 'Как Вас зовут?',
        vocal: 'Kak waß sawu̒t?',
      },
      {
        de: 'Ich heiße…',
        ru: 'Меня зовут...',
        vocal: 'Minjа́ sawu̒t…',
      },
      {
        de: 'Ich bin…',
        ru: 'Я ...',
        vocal: 'Ja …',
      },
      {
        de: 'Es ist schön Sie kennenzulernen',
        ru: 'Приятно с Вами познакомиться',
        vocal: 'Prijа́tna ß wа́mi pasnakо́mitza',
      },
      {
        de: 'Ich bin X Jahre alt',
        ru: 'Мне X лет',
        vocal: 'Mne X let.',
      },
      {
        de: 'Ich komme aus…',
        ru: 'Я из ...',
        vocal: 'Ja is …',
      },
      {
        de: 'Wie alt sind Sie?',
        ru: 'Сколько Вам лет?',
        vocal: 'ßkо́lka wam let?',
      },
      {
        de: 'Wo arbeiten Sie?',
        ru: 'Где Вы работаете?',
        vocal: 'Gde wy rabо́taiti?',
      },
      {
        de: 'Wo kommen Sie her?',
        ru: 'Откуда Вы?',
        vocal: 'Atku̒da wy?',
      },
      {
        de: 'Was bringt Sie hierher?',
        ru: 'Что привело Вас сюда?',
        vocal: 'Schto priwilо́ waß ßjudа́?',
      },
      {
        de: 'Wie war Ihre Reise?',
        ru: 'Как прошла Ваша поездка?',
        vocal: 'Kak praschlа́ wа́scha pajе́sdka?',
      },
      {
        de: 'Haben Sie eine gute Zeit?',
        ru: 'Вы хорошо проводите время?',
        vocal: 'Wy charaschо́ prawо́dite wrе́mja?',
      },
      {
        de: 'Was halten Sie von …?',
        ru: 'Что Вы думаете о ...?',
        vocal: 'Schto wy du̒maiti a ...?',
      },
      {
        de: 'Meine Freunde nennen mich …',
        ru: 'Мои друзья зовут меня ...',
        vocal: 'Mai̒ drusjа́ sawu̒t minjа́ ...',
      },
      {
        de: 'Kennen wir uns?',
        ru: 'Мы знакомы?',
        vocal: 'My snakо́my?',
      },
      {
        de: 'Dies ist (Name)',
        ru: 'Это (имя)',
        vocal: 'Äta (i̒mja)',
      },
      {
        de: 'Wie war Ihr Wochenende?',
        ru: 'Как прошли Ваши выходные?',
        vocal: 'Kak praschli̒ wа́schy wychadny̒je?',
      },
    ],
  },
  {
    de: 'Begrüssung / Verabschiedung',
    vocabularies: [
      {
        de: 'Hey',
        ru: 'Здорого',
        vocal: 'Zdorovo',
      },
      {
        de: 'Guten Morgen',
        ru: 'Доброе утро',
        vocal: 'Dо́braje u̒tra',
      },
      {
        de: 'Guten Tag',
        ru: 'Добрый день. Здравствуй(те)',
        vocal: 'Dо́bryj den. Sdrа́ßtwuj(ti)',
      },
      {
        de: 'Guten Abend',
        ru: 'Добрый вечер',
        vocal: 'Dо́bryj wе́tschir',
      },
      {
        de: 'Gute Nacht',
        ru: 'Спокойной ночи',
        vocal: 'ßpakо́jnaj nо́tschi',
      },
      {
        de: 'Tschüss',
        ru: 'Пока',
        vocal: 'Pakа́',
      },
      {
        de: 'Auf Wiedersehen',
        ru: 'До свидания',
        vocal: 'Da ßwidа́nja',
      },
      {
        de: 'Wie geht es Ihnen?',
        ru: 'Как у Вас дела?',
        vocal: 'Kak u waß di̒la?',
      },
      {
        de: 'Gut',
        ru: 'хорошо',
        vocal: 'charaschо́',
      },
      {
        de: 'Schlecht',
        ru: 'плохо',
        vocal: 'plо́cha',
      },
      {
        de: 'Hey / Hallo',
        ru: 'Привет',
        vocal: 'Priwе́t',
      },
      {
        de: "Wie geht's?",
        ru: 'Как дела?',
        vocal: 'Kak di̒la?',
      },
      {
        de: 'Was gibt’s neues?',
        ru: 'Что нового?',
        vocal: 'Schto nо́wawa?',
      },
      {
        de: 'Schön Sie zu sehen.',
        ru: 'Рад(а) Вас видеть.',
        vocal: 'Rа́d(a) waß wi̒det.',
      },
      {
        de: 'Nett Sie kennenzulernen',
        ru: 'Приятно с Вами познакомиться',
        vocal: 'Prijа́tna ß wа́mi pasnakо́mitza',
      },
      {
        de: "Mach's gut",
        ru: 'Всего хорошего',
        vocal: 'Vsego khoroshego',
      },
      {
        de: 'Lange nicht gesehen',
        ru: 'Давно не виделись',
        vocal: 'Dawnо́ ni wi̒dilis',
      },
      {
        de: "Wie steht's?",
        ru: 'Как обстоят дела?',
        vocal: 'Kak abßtajа́t di̒la?',
      },
    ],
  },
  {
    de: 'Reise',
    vocabularies: [
      {
        de: 'Ich möchte gerne…',
        ru: 'Я бы хотел(а)...',
        vocal: 'Ja by chatе́l(a)…',
      },
      {
        de: 'Wo sind die Toilleten?',
        ru: 'Где здесь туалет?',
        vocal: 'Gde sdes tualе́t?',
      },
      {
        de: 'Wie spät ist es?',
        ru: 'Который час?',
        vocal: 'Katо́ryj tschaß?',
      },
      {
        de: 'Ich übernachte bei…',
        ru: 'Я ночую у ...',
        vocal: 'Ja natschu̒ju u ...',
      },
      {
        de: 'Ich besuche Familie',
        ru: 'Я навещаю семью',
        vocal: 'Ja nawischtschа́ju ßimju̒',
      },
      {
        de: 'Ich bin hier für X Tage',
        ru: 'Я здесь на X дня (дней)',
        vocal: 'Ja sdes na X dnja (dnej)',
      },
      {
        de: 'Haben Sie eine Karte?',
        ru: 'У вас есть карта?',
        vocal: 'U waß jeßt kа́rta?',
      },
      {
        de: 'Reisepass',
        ru: 'загранпаспорт',
        vocal: 'sagranpа́ßpart',
      },
      {
        de: 'Flughafen',
        ru: 'аэропорт',
        vocal: 'aärapo̒rt',
      },
      {
        de: 'Hafen',
        ru: 'порт, гавань',
        vocal: 'port, gа́wan',
      },
      {
        de: 'Sicherheit',
        ru: 'безопасность',
        vocal: 'bisapа́ßnaßt',
      },
      {
        de: 'Flugzeug',
        ru: 'самолёт',
        vocal: 'ßamaljo̒t',
      },
      {
        de: 'Zug',
        ru: 'поезд',
        vocal: 'po̒jisd',
      },
      {
        de: 'Schiff',
        ru: 'корабль',
        vocal: 'karа́bl',
      },
      {
        de: 'Fahrrad',
        ru: 'велосипед',
        vocal: 'wilaßipе́d',
      },
      {
        de: 'Motorrad',
        ru: 'мотоцикл',
        vocal: 'matatzy̒kl',
      },
      {
        de: 'Bus',
        ru: 'автобус',
        vocal: 'afto̒buß',
      },
      {
        de: 'fliegen',
        ru: 'лететь',
        vocal: 'litе́t',
      },
      {
        de: 'fahren',
        ru: 'ехать',
        vocal: 'jе́chat',
      },
      {
        de: 'segeln',
        ru: 'ходить под парусом',
        vocal: 'chadi̒t pad pа́rußam',
      },
    ],
  },
  {
    de: 'Wegbeschreibungen',
    vocabularies: [
      {
        de: 'links',
        ru: 'слева',
        vocal: 'ßlе́wa',
      },
      {
        de: 'rechts',
        ru: 'справа',
        vocal: 'ßprа́wa',
      },
      {
        de: 'hier',
        ru: 'здесь, тут',
        vocal: 'sdes, tut',
      },
      {
        de: 'dort',
        ru: 'там',
        vocal: 'tam',
      },
      {
        de: 'zurück',
        ru: 'обратно, назад',
        vocal: 'abrа́tna, nasа́d',
      },
      {
        de: 'hoch',
        ru: 'вверх',
        vocal: 'wwerch',
      },
      {
        de: 'runter',
        ru: 'вниз',
        vocal: 'wnis',
      },
      {
        de: 'geradeaus',
        ru: 'прямо',
        vocal: 'prjа́ma',
      },
      {
        de: 'Ort',
        ru: 'населённый пункт, место',
        vocal: 'naßiljo̒nyj punkt, mе́sta',
      },
      {
        de: 'Wo ist…?',
        ru: 'Где находится ...?',
        vocal: 'Gde nacho̒ditza …?',
      },
      {
        de: 'Wie komme ich nach…?',
        ru: 'Как мне пройти к ...?',
        vocal: 'Kak mnje prajti̒ k …?',
      },
      {
        de: 'Ich suche ... Straße.',
        ru: 'Я ищу улицу ... .',
        vocal: 'Ja ischtschu̒ u̒litzu … .',
      },
      {
        de: 'um die Ecke',
        ru: 'за углом',
        vocal: 'sa uglo̒m',
      },
      {
        de: 'weit',
        ru: 'далеко',
        vocal: 'daliko̒',
      },
      {
        de: 'in der Nähe von',
        ru: 'недалеко от, близко от',
        vocal: 'nidaliko̒ at, bli̒ska at',
      },
      {
        de: 'gegenüber von',
        ru: 'напротив',
        vocal: 'napro̒tif',
      },
      {
        de: 'Folgen Sie mir',
        ru: 'Идите за мной',
        vocal: 'Idi̒te sa mnoj',
      },
      {
        de: 'neben X',
        ru: 'рядом с X',
        vocal: 'rjа́dam ß X',
      },
      {
        de: 'vorbeigehen',
        ru: 'проходить мимо',
        vocal: 'prachadi̒t mi̒ma',
      },
      {
        de: 'zwischen',
        ru: 'между',
        vocal: 'mе́shdu',
      },
    ],
  },
  {
    de: 'Zeiten / Daten',
    vocabularies: [
      {
        de: 'jetzt',
        ru: 'сейчас',
        vocal: 'ßijtschа́ß',
      },
      {
        de: 'heute',
        ru: 'сегодня',
        vocal: 'ßiwo̒dnja',
      },
      {
        de: 'morgen',
        ru: 'завтра',
        vocal: 'sа́ftra',
      },
      {
        de: 'gestern',
        ru: 'вчера',
        vocal: 'ftschirа́',
      },
      {
        de: 'Sekunde',
        ru: 'секунда',
        vocal: 'ßiku̒nda',
      },
      {
        de: 'Minute',
        ru: 'минута',
        vocal: 'minu̒ta',
      },
      {
        de: 'Stunde',
        ru: 'час',
        vocal: 'tschaß',
      },
      {
        de: 'Tag',
        ru: 'день',
        vocal: 'den',
      },
      {
        de: 'Woche',
        ru: 'неделя',
        vocal: 'nidе́lja',
      },
      {
        de: 'Monat',
        ru: 'месяц',
        vocal: 'mе́ßitz',
      },
      {
        de: 'Jahr',
        ru: 'год',
        vocal: 'god',
      },
      {
        de: 'früh',
        ru: 'рано',
        vocal: 'rа́na',
      },
      {
        de: 'spät',
        ru: 'поздно',
        vocal: 'po̒sdna',
      },
      {
        de: 'Montag',
        ru: 'понедельник',
        vocal: 'panidе́lnik',
      },
      {
        de: 'Dienstag',
        ru: 'вторник',
        vocal: 'fto̒rnik',
      },
      {
        de: 'Mittwoch',
        ru: 'среда',
        vocal: 'ßridа́',
      },
      {
        de: 'Donnerstag',
        ru: 'четверг',
        vocal: 'tschitwе́rg',
      },
      {
        de: 'Freitag',
        ru: 'пятница',
        vocal: 'pjа́tnitza',
      },
      {
        de: 'Samstag',
        ru: 'суббота',
        vocal: 'ßubo̒ta',
      },
      {
        de: 'Sonntag',
        ru: 'воскресенье',
        vocal: 'waskrißе́nje',
      },
      {
        de: 'Frühling',
        ru: 'весна',
        vocal: 'wisnа́',
      },
      {
        de: 'Sommer',
        ru: 'лето',
        vocal: 'lе́ta',
      },
      {
        de: 'Herbst',
        ru: 'осень',
        vocal: 'o̒ßin',
      },
      {
        de: 'Winter',
        ru: 'зима',
        vocal: 'simа́',
      },
      {
        de: 'Januar',
        ru: 'январь',
        vocal: 'janwа́r',
      },
      {
        de: 'Februar',
        ru: 'февраль',
        vocal: 'fiwrа́l',
      },
      {
        de: 'März',
        ru: 'март',
        vocal: 'mart',
      },
      {
        de: 'April',
        ru: 'апрель',
        vocal: 'aprе́l',
      },
      {
        de: 'Mai',
        ru: 'май',
        vocal: 'maj',
      },
      {
        de: 'Juni',
        ru: 'июнь',
        vocal: 'iju̒n',
      },
      {
        de: 'Juli',
        ru: 'июль',
        vocal: 'iju̒l',
      },
      {
        de: 'August',
        ru: 'август',
        vocal: 'а́wgust',
      },
      {
        de: 'September',
        ru: 'сентябрь',
        vocal: 'ßintjа́br',
      },
      {
        de: 'Oktober',
        ru: 'октябрь',
        vocal: 'aktjа́br',
      },
      {
        de: 'November',
        ru: 'ноябрь',
        vocal: 'najа́br',
      },
      {
        de: 'Dezember',
        ru: 'декабрь',
        vocal: 'dikа́br',
      },
      {
        de: 'Uhrzeit',
        ru: 'время',
        vocal: 'wrе́mja',
      },
      {
        de: 'Jahrzehnt',
        ru: 'десятилетие',
        vocal: 'dißjatilе́tije',
      },
      {
        de: 'Jahrhundert',
        ru: 'столетие, век',
        vocal: 'ßtalе́tije, wek',
      },
    ],
  },
  {
    de: 'Orte',
    vocabularies: [
      {
        de: 'Supermarkt',
        ru: 'супермаркет',
        vocal: 'ßupirmа́rkit',
      },
      {
        de: 'Krankenhaus',
        ru: 'больница',
        vocal: 'balni̒tza',
      },
      {
        de: 'Bank',
        ru: 'банк',
        vocal: 'bank',
      },
      {
        de: 'Hotel',
        ru: 'гостиница, отель',
        vocal: 'gaßti̒nitza, atä̒l',
      },
      {
        de: 'Bar',
        ru: 'бар',
        vocal: 'bar',
      },
      {
        de: 'Apotheke',
        ru: 'аптека',
        vocal: 'aptе́ka',
      },
      {
        de: 'Strand',
        ru: 'пляж',
        vocal: 'pljash',
      },
      {
        de: 'Restaurant',
        ru: 'ресторан',
        vocal: 'rißtarа́n',
      },
      {
        de: 'Bäckerei',
        ru: 'булочная',
        vocal: 'bu̒latschnaja',
      },
      {
        de: 'Bushaltestelle',
        ru: 'автобусная остановка',
        vocal: 'afto̒bußnaja aßtano̒fka',
      },
      {
        de: 'Kirche',
        ru: 'церковь',
        vocal: 'tzä̒rkaf',
      },
      {
        de: 'Kino',
        ru: 'кинотеатр',
        vocal: 'kinatiа́tr',
      },
      {
        de: 'Tankstelle',
        ru: 'заправочная станция (заправка)',
        vocal: 'saprа́watschnaja ßtа́ntzija (saprа́fka)',
      },
      {
        de: 'Museum',
        ru: 'музей',
        vocal: 'musе́j',
      },
      {
        de: 'Polizeistation',
        ru: 'полицейский участок',
        vocal: 'palitzä̒jskij utschа́stak',
      },
      {
        de: 'Schule',
        ru: 'школа',
        vocal: 'schko̒la',
      },
      {
        de: 'Platz',
        ru: 'площадь',
        vocal: 'plo̒schtschad',
      },
      {
        de: 'Zoo',
        ru: 'зоопарк',
        vocal: 'saapа́rk',
      },
    ],
  },
  {
    de: 'Einkaufen',
    vocabularies: [
      {
        de: 'teuer',
        ru: 'дорого',
        vocal: 'do̒raga',
      },
      {
        de: 'billig',
        ru: 'дёшево',
        vocal: 'djo̒schewa',
      },
      {
        de: 'kostenlos',
        ru: 'бесплатно',
        vocal: 'bißplа́tna',
      },
      {
        de: 'Wie viel kostet das?',
        ru: 'Сколько это стоит?',
        vocal: 'ßko̒lka ä̒ta ßto̒it?',
      },
      {
        de: 'Kassierer',
        ru: 'кассир',
        vocal: 'kaßi̒r',
      },
      {
        de: 'Trolley / Warenkorb',
        ru: 'тележка / корзинка для покупок',
        vocal: 'tilе́shka / karsi̒nka dlja paku̒pak',
      },
      {
        de: 'Tasche',
        ru: 'сумка',
        vocal: 'ßu̒mka',
      },
      {
        de: 'Garantie',
        ru: 'гарантия',
        vocal: 'garа́ntija',
      },
      {
        de: 'Rückgaberecht',
        ru: 'право возврата товара',
        vocal: 'prа́wa waswrа́ta tawа́ra',
      },
      {
        de: 'Kundenkarte',
        ru: 'карта клиента',
        vocal: 'kа́rta klijе́nta',
      },
      {
        de: 'Mehrwertsteuer-Quittung',
        ru: 'квитанция с НДС',
        vocal: 'kwitа́ntzija s än dä äs',
      },
      {
        de: 'Rabatt',
        ru: 'скидка',
        vocal: 'ßki̒dka',
      },
      {
        de: 'Gang',
        ru: 'ряд',
        vocal: 'rjad',
      },
      {
        de: 'Regal',
        ru: 'полка',
        vocal: 'po̒lka',
      },
      {
        de: 'Umkleidekabine',
        ru: 'примерочная кабина',
        vocal: 'primе́ratschnaja kabi̒na',
      },
      {
        de: 'Lieferung',
        ru: 'поставка',
        vocal: 'pastа́fka',
      },
      {
        de: 'Schlussverkauf',
        ru: 'сезонная распродажа',
        vocal: 'ßiso̒naja raspradа́sha',
      },
      {
        de: 'Entschuldigen Sie, arbeiten Sie hier?',
        ru: 'Извините, Вы здесь работаете?',
        vocal: 'Iswini̒te, wy sdes rabo̒taite?',
      },
    ],
  },
  {
    de: 'Im Restaurant',
    vocabularies: [
      {
        de: 'Einen Tisch für X Personen, bitte.',
        ru: 'Столик на X человек(а), пожалуйста.',
        vocal: 'ßto̒lik na X tschelowе́k(a), pashа́lujßta.',
      },
      {
        de: 'Ich würde gerne bestellen.',
        ru: 'Я бы хотел(а) заказать.',
        vocal: 'Ja by chatе́l(a) sakasа́t.',
      },
      {
        de: 'Kann ich bitte die Karte haben?',
        ru: 'Дайте меню, пожалуйста.',
        vocal: 'Dа́jte menju̒, pashа́lujßta.',
      },
      {
        de: 'Die Rechnung bitte.',
        ru: 'Счёт, пожалуйста.',
        vocal: 'ßtschjot, pashа́lujßta.',
      },
      {
        de: 'Frühstück',
        ru: 'завтрак',
        vocal: 'sа́ftrak',
      },
      {
        de: 'Mittagsessen',
        ru: 'обед',
        vocal: 'abе́d',
      },
      {
        de: 'Abendessen',
        ru: 'ужин',
        vocal: 'u̒shin',
      },
      {
        de: 'Besteck',
        ru: 'столовые приборы',
        vocal: 'stalo̒wyje pribo̒ry',
      },
      {
        de: 'Serviette',
        ru: 'салфетка',
        vocal: 'ßalfе́tka',
      },
      {
        de: 'Brunch',
        ru: 'второй завтрак',
        vocal: 'ftaro̒j sа́ftrak',
      },
      {
        de: 'Hauptgang',
        ru: 'основное блюдо',
        vocal: 'aßnawno̒je blju̒da',
      },
      {
        de: 'Dessert',
        ru: 'десерт',
        vocal: 'dißе́rt',
      },
      {
        de: 'Trinkgeld',
        ru: 'чаевые',
        vocal: 'tschajiwy̒je',
      },
      {
        de: 'Beilage',
        ru: 'гарнир',
        vocal: 'garni̒r',
      },
      {
        de: 'Getränke',
        ru: 'напитки',
        vocal: 'napi̒tki',
      },
      {
        de: 'So viel du essen kannst',
        ru: 'шведский стол',
        vocal: 'schwе́dskij ßtol',
      },
      {
        de: 'Happy Hour',
        ru: 'акция "счастливые часы"',
        vocal: 'а́kzija "schtschaßli̒wyje tschaßy̒"',
      },
      {
        de: 'Appetizer',
        ru: 'закуски',
        vocal: 'saku̒ßki',
      },
    ],
  },
  {
    de: 'Im Hotel',
    vocabularies: [
      {
        de: 'Zimmer',
        ru: 'номер, комната',
        vocal: 'no̒mir, ko̒mnata',
      },
      {
        de: 'Zimmerservice',
        ru: 'обслуживание номеров',
        vocal: 'abslu̒shiwanije namiro̒f',
      },
      {
        de: 'Badezimmer',
        ru: 'ванная комната',
        vocal: 'wа́naja ko̒mnata',
      },
      {
        de: 'Bett',
        ru: 'кровать',
        vocal: 'krawа́t',
      },
      {
        de: 'Schlafzimmer',
        ru: 'спальня',
        vocal: 'ßpа́lnja',
      },
      {
        de: 'Etage',
        ru: 'этаж',
        vocal: 'ätа́sh',
      },
      {
        de: 'Aufzug',
        ru: 'лифт',
        vocal: 'lift',
      },
      {
        de: 'Rezeption',
        ru: 'стойка администратора (ресепшен)',
        vocal: 'ßto̒jka adminißtrа́tara (rißä̒pschen)',
      },
      {
        de: 'Handtuch',
        ru: 'полотенце',
        vocal: 'palatе́ntze',
      },
      {
        de: 'Nebenräume',
        ru: 'соседние комнаты',
        vocal: 'ßaßе́dnije ko̒mnaty',
      },
      {
        de: 'Gepäck',
        ru: 'багаж',
        vocal: 'bagа́sh',
      },
      {
        de: 'Page',
        ru: 'посыльный',
        vocal: 'paßy̒lnyj',
      },
      {
        de: 'Kochnische',
        ru: 'миникухня',
        vocal: 'miniku̒chnja',
      },
      {
        de: 'Bettwäsche',
        ru: 'постельное бельё',
        vocal: 'paßtе́lnaje biljo̒',
      },
      {
        de: 'Kammerdiener',
        ru: 'камердинер',
        vocal: 'kamerdi̒ner',
      },
      {
        de: 'Lobby',
        ru: 'лобби',
        vocal: 'lo̒bi',
      },
      {
        de: 'Anzahlung',
        ru: 'аванс',
        vocal: 'awа́nß',
      },
      {
        de: 'Einchecken',
        ru: 'заселиться в гостиницу',
        vocal: 'saßili̒tza w gaßti̒nitzu',
      },
      {
        de: 'Auschecken',
        ru: 'выехать из гостиницы',
        vocal: 'wy̒jechat is gaßti̒nitzy',
      },
      {
        de: 'Gratis',
        ru: 'бесплатно',
        vocal: 'bißplа́tna',
      },
    ],
  },
  {
    de: 'Zahlen',
    vocabularies: [
      {
        de: 'Eins',
        ru: 'один',
        vocal: 'adi̒n',
      },
      {
        de: 'Zwei',
        ru: 'два',
        vocal: 'dwa',
      },
      {
        de: 'Drei',
        ru: 'три',
        vocal: 'tri',
      },
      {
        de: 'Vier',
        ru: 'четыре',
        vocal: 'tschity̒ri',
      },
      {
        de: 'Fünf',
        ru: 'пять',
        vocal: 'pjat',
      },
      {
        de: 'Sechs',
        ru: 'шесть',
        vocal: 'scheßt',
      },
      {
        de: 'Sieben',
        ru: 'семь',
        vocal: 'ßem',
      },
      {
        de: 'Acht',
        ru: 'восемь',
        vocal: 'wo̒ßim',
      },
      {
        de: 'Neun',
        ru: 'девять',
        vocal: 'dе́wjat',
      },
      {
        de: 'Zehn',
        ru: 'десять',
        vocal: 'dе́ßjat',
      },
      {
        de: 'Elf',
        ru: 'одиннадцать',
        vocal: 'adi̒natzat',
      },
      {
        de: 'Zwölf',
        ru: 'двенадцать',
        vocal: 'dwinа́tzat',
      },
      {
        de: 'Dreizehn',
        ru: 'тринадцать',
        vocal: 'trinа́tzat',
      },
      {
        de: 'Vierzehn',
        ru: 'четырнадцать',
        vocal: 'tschity̒rnatzat',
      },
      {
        de: 'Fünfzehn',
        ru: 'пятнадцать',
        vocal: 'pitnа́tzat',
      },
      {
        de: 'Sechszehn',
        ru: 'шестнадцать',
        vocal: 'schyßnа́tzat',
      },
      {
        de: 'Siebzehn',
        ru: 'семнадцать',
        vocal: 'ßimnа́tzat',
      },
      {
        de: 'Achtzehn',
        ru: 'восемнадцать',
        vocal: 'waßimnа́tzat',
      },
      {
        de: 'Neunzehn',
        ru: 'девятнадцать',
        vocal: 'diwjatnа́tzat',
      },
      {
        de: 'Zwanzig',
        ru: 'двадцать',
        vocal: 'dwа́tzat',
      },
      {
        de: 'Dreißig',
        ru: 'тридцать',
        vocal: 'tri̒tzat',
      },
      {
        de: 'Vierzig',
        ru: 'сорок',
        vocal: 'ßo̒rak',
      },
      {
        de: 'Fünfzig',
        ru: 'пятьдесят',
        vocal: 'pidißjа́t',
      },
      {
        de: 'Sechszig',
        ru: 'шестьдесят',
        vocal: 'schyßdißjа́t',
      },
      {
        de: 'Siebzieg',
        ru: 'семьдесят',
        vocal: 'ßе́mdißat',
      },
      {
        de: 'Achzig',
        ru: 'восемьдесят',
        vocal: 'wo̒ßimdißat',
      },
      {
        de: 'Neunzig',
        ru: 'девяносто',
        vocal: 'diwino̒ßta',
      },
      {
        de: 'Hundert',
        ru: 'сто',
        vocal: 'ßto',
      },
      {
        de: 'Zweihundert',
        ru: 'двести',
        vocal: 'dwе́ßti',
      },
      {
        de: 'Tausend',
        ru: 'тысяча',
        vocal: 'ty̒ßitscha',
      },
      {
        de: 'Zweitausend',
        ru: 'две тысячи',
        vocal: 'dwe ty̒ßitschi',
      },
      {
        de: 'Million',
        ru: 'миллион',
        vocal: 'milio̒n',
      },
      {
        de: 'Milliarde',
        ru: 'миллиард',
        vocal: 'miliа́rd',
      },
      {
        de: 'erste(r)',
        ru: 'первая (первый)',
        vocal: 'pе́rwaja(pе́rwyj)',
      },
      {
        de: 'zweite(r)',
        ru: 'вторая (второй)',
        vocal: 'ftarа́ja (ftaro̒j)',
      },
      {
        de: 'dritte(r)',
        ru: 'третья (третий)',
        vocal: 'trе́tja (trе́tij)',
      },
      {
        de: 'vierte(r)',
        ru: 'четвёртая (четвёртый)',
        vocal: 'tschitwjo̒rtaja (tschitwjo̒rtyj)',
      },
      {
        de: 'fünfte(r)',
        ru: 'пятая (пятый)',
        vocal: 'pjа́taja (pjа́tyj)',
      },
      {
        de: 'sechste(r)',
        ru: 'шестая (шестой)',
        vocal: 'scheßtа́ja (scheßto̒j)',
      },
      {
        de: 'siebte(r)',
        ru: 'седьмая (седьмой)',
        vocal: 'ßedmа́ja (ßedmo̒j)',
      },
    ],
  },
  {
    de: 'Personalpronomen',
    vocabularies: [
      {
        de: 'ich',
        ru: 'я',
        vocal: 'ja',
      },
      {
        de: 'du',
        ru: 'ты',
        vocal: 'ty',
      },
      {
        de: 'er',
        ru: 'он',
        vocal: 'on',
      },
      {
        de: 'sie',
        ru: 'она',
        vocal: 'anа́',
      },
      {
        de: 'es',
        ru: 'оно',
        vocal: 'ano̒',
      },
      {
        de: 'wir',
        ru: 'мы',
        vocal: 'my',
      },
      {
        de: 'ihr',
        ru: 'вы',
        vocal: 'wy',
      },
      {
        de: 'sie',
        ru: 'они',
        vocal: 'ani̒',
      },
    ],
  },
  {
    de: 'Wichtige Wörter',
    vocabularies: [
      {
        de: 'Ding',
        ru: 'вещь, предмет',
        vocal: 'wetschsch, pridmе́t',
      },
      {
        de: 'sicher',
        ru: 'безопасный',
        vocal: 'bisapа́ßnyj',
      },
      {
        de: 'und',
        ru: 'и',
        vocal: 'i',
      },
      {
        de: 'oder',
        ru: 'или',
        vocal: 'i̒li',
      },
      {
        de: 'weil',
        ru: 'потому что',
        vocal: 'patamu̒ schta',
      },
      {
        de: 'Leben',
        ru: 'жизнь',
        vocal: 'shysn',
      },
      {
        de: 'Regierung',
        ru: 'правительство',
        vocal: 'prawi̒telßtwa',
      },
      {
        de: 'Kind',
        ru: 'ребёнок',
        vocal: 'ribjo̒nak',
      },
      {
        de: 'Firma',
        ru: 'фирма',
        vocal: 'fi̒rma',
      },
      {
        de: 'Gruppe',
        ru: 'группа',
        vocal: 'gru̒pa',
      },
      {
        de: 'Alter',
        ru: 'возраст',
        vocal: 'wo̒sraßt',
      },
      {
        de: 'Mond',
        ru: 'луна (Himmelskörper, Vollmond), месяц (Neumond)',
        vocal: 'lunа́, mе́ßitz',
      },
      {
        de: 'Sonne',
        ru: 'солнце',
        vocal: 'ßo̒lntzä',
      },
      {
        de: 'Auto',
        ru: 'машина, автомобиль',
        vocal: 'maschy̒na, aftamabi̒l',
      },
      {
        de: 'Buch',
        ru: 'книга',
        vocal: 'kni̒ga',
      },
      {
        de: 'Welt',
        ru: 'мир',
        vocal: 'mir',
      },
      {
        de: 'Familie',
        ru: 'семья',
        vocal: 'ßimjа́',
      },
      {
        de: 'Freund',
        ru: 'друг',
        vocal: 'drug',
      },
      {
        de: 'Gesetz',
        ru: 'закон',
        vocal: 'sako̒n',
      },
    ],
  },
  {
    de: 'Mensch / Körper',
    vocabularies: [
      {
        de: 'Mann',
        ru: 'мужчина',
        vocal: 'muschtschi̒na',
      },
      {
        de: 'Frau',
        ru: 'женщина',
        vocal: 'shе́nschtschina',
      },
      {
        de: 'Junge',
        ru: 'мальчик',
        vocal: 'mа́ltschik',
      },
      {
        de: 'Mädchen',
        ru: 'девочка',
        vocal: 'dе́watschka',
      },
      {
        de: 'Arm',
        ru: 'рука',
        vocal: 'rukа́',
      },
      {
        de: 'Hand',
        ru: 'рука, ладонь',
        vocal: 'rukа́, lado̒n',
      },
      {
        de: 'Bein',
        ru: 'нога',
        vocal: 'nagа́',
      },
      {
        de: 'Fuß',
        ru: 'нога, ступня',
        vocal: 'nagа́, ßtupnjа́',
      },
      {
        de: 'Auge',
        ru: 'глаз',
        vocal: 'glas',
      },
      {
        de: 'Kopf',
        ru: 'голова',
        vocal: 'galawа́',
      },
      {
        de: 'Gehirn',
        ru: 'мозг',
        vocal: 'mosg',
      },
      {
        de: 'Nase',
        ru: 'нос',
        vocal: 'nos',
      },
      {
        de: 'Ohr',
        ru: 'ухо',
        vocal: 'u̒cha',
      },
      {
        de: 'Haar',
        ru: 'волос(ы)',
        vocal: 'wo̒laßy',
      },
      {
        de: 'Augenbraue',
        ru: 'бровь',
        vocal: 'brof',
      },
      {
        de: 'Lippen',
        ru: 'губы',
        vocal: 'gu̒by',
      },
      {
        de: 'Finger',
        ru: 'палец (Pl. пальцы)',
        vocal: 'pа́litz (Pl. pа́ltzy)',
      },
      {
        de: 'Skelett',
        ru: 'скелет',
        vocal: 'skilе́t',
      },
      {
        de: 'Knochen',
        ru: 'кость (Pl. кости)',
        vocal: 'koßt (Pl. ko̒ßti)',
      },
      {
        de: 'Haut',
        ru: 'кожа',
        vocal: 'ko̒sha',
      },
    ],
  },
  {
    de: 'Wichtige Verben',
    vocabularies: [
      {
        de: 'sein',
        ru: 'быть',
        vocal: 'byt',
      },
      {
        de: 'bekommen',
        ru: 'получать (получить)',
        vocal: 'palutschа́t (palutschi̒t)',
      },
      {
        de: 'geben',
        ru: 'давать (дать)',
        vocal: 'dawа́t (dat)',
      },
      {
        de: 'leben',
        ru: 'жить',
        vocal: 'shyt',
      },
      {
        de: 'machen',
        ru: 'делать',
        vocal: 'dе́lat',
      },
      {
        de: 'gehen',
        ru: 'идти, ходить',
        vocal: 'idti̒, chadi̒t',
      },
      {
        de: 'benutzen',
        ru: 'использовать',
        vocal: 'ißpo̒lsawat',
      },
      {
        de: 'essen',
        ru: 'есть, кушать',
        vocal: 'jeßt, ku̒schat',
      },
      {
        de: 'denken',
        ru: 'думать',
        vocal: 'du̒mat',
      },
      {
        de: 'kommen',
        ru: 'приходить (прийти)',
        vocal: 'prichadi̒t (prijti̒)',
      },
      {
        de: 'haben',
        ru: 'иметь',
        vocal: 'imе́t',
      },
      {
        de: 'tun',
        ru: 'делать',
        vocal: 'dе́lat',
      },
      {
        de: 'sagen',
        ru: 'говорить, сказать',
        vocal: 'gawari̒t, ßkasа́t',
      },
      {
        de: 'wissen',
        ru: 'знать',
        vocal: 'snat',
      },
      {
        de: 'sehen',
        ru: 'видеть, смотреть',
        vocal: 'wi̒dit, smatrе́t',
      },
      {
        de: 'wollen',
        ru: 'хотеть',
        vocal: 'chatе́t',
      },
      {
        de: 'finden',
        ru: 'находить (найти)',
        vocal: 'nachadi̒t (najti̒)',
      },
      {
        de: 'erzählen',
        ru: 'рассказывать (рассказать)',
        vocal: 'raßkа́sywat (raßkasа́t)',
      },
      {
        de: 'fragen',
        ru: 'спрашивать (спросить)',
        vocal: 'ßprа́schiwat (ßpraßi̒t)',
      },
      {
        de: 'versuchen',
        ru: 'пытаться, пробовать',
        vocal: 'pytа́tza, pro̒bawat',
      },
      {
        de: 'anrufen',
        ru: 'звонить',
        vocal: 'swani̒t',
      },
    ],
  },
  {
    de: 'Wichtige Adjektive',
    vocabularies: [
      {
        de: 'schön',
        ru: 'красивый',
        vocal: 'kraßi̒wyj',
      },
      {
        de: 'hässlich',
        ru: 'уродливый, некрасивый',
        vocal: 'uro̒dliwyj, nikraßi̒wyj',
      },
      {
        de: 'hoch',
        ru: 'высокий',
        vocal: 'wyßo̒kij',
      },
      {
        de: 'klein',
        ru: 'маленький',
        vocal: 'mа́linkij',
      },
      {
        de: 'groß',
        ru: 'большой',
        vocal: 'balscho̒j',
      },
      {
        de: 'neu',
        ru: 'новый',
        vocal: 'no̒wyj',
      },
      {
        de: 'lang',
        ru: 'длинный, долгий',
        vocal: 'dli̒nyj',
      },
      {
        de: 'großartig',
        ru: 'прекрасный, чудесный',
        vocal: 'prikrа́ßnyj',
      },
      {
        de: 'alt',
        ru: 'старый',
        vocal: 'ßtа́ryj',
      },
      {
        de: 'jung',
        ru: 'молодой',
        vocal: 'malado̒j',
      },
      {
        de: 'anders',
        ru: 'другой',
        vocal: 'drugo̒j',
      },
      {
        de: 'wichtig',
        ru: 'важный',
        vocal: 'wа́shnyj',
      },
      {
        de: 'schlecht',
        ru: 'плохой',
        vocal: 'placho̒j',
      },
      {
        de: 'lustig',
        ru: 'весёлый',
        vocal: 'wißjo̒lyj',
      },
      {
        de: 'ernst',
        ru: 'серьёзный',
        vocal: 'ßirjo̒snyj',
      },
      {
        de: 'stark',
        ru: 'сильный',
        vocal: 'ßi̒lnyj',
      },
      {
        de: 'einfach',
        ru: 'простой',
        vocal: 'praßto̒j',
      },
      {
        de: 'schwer',
        ru: 'сложный, трудный, тяжёлый',
        vocal: 'ßlo̒shnyj, tru̒dnyj, tjasho̒lyj',
      },
      {
        de: 'arm',
        ru: 'бедный',
        vocal: 'bе́dnyj',
      },
      {
        de: 'reich',
        ru: 'богатый',
        vocal: 'bagа́tyj',
      },
    ],
  },
];
